// Formato del lote/OP de captura de la empresa (B7, propuesta
// 2026-10-alimentos-rionegro). La regla viene de /api/me vía useTenantConfig;
// la validación final la hace el API con el mismo valor (código
// `lote_formato_invalido`). Acá solo se adelanta el error en el formulario y
// se arma el placeholder y el filtro de tecleo.

import {
  FORMATO_LOTE_AYUDA_DEFAULT,
  FORMATO_LOTE_EJEMPLO_DEFAULT,
  FORMATO_LOTE_REGEX_DEFAULT,
  LOTE_MAX_LEN,
  mensajeLoteInvalido,
  validarLote,
} from 'schemas';

export interface FormatoLote {
  regex: string;
  ejemplo: string;
  ayuda: string;
}

/** Regla histórica (8 dígitos): default mientras carga /api/me. */
export const FORMATO_LOTE_DEFAULT: FormatoLote = {
  regex: FORMATO_LOTE_REGEX_DEFAULT,
  ejemplo: FORMATO_LOTE_EJEMPLO_DEFAULT,
  ayuda: FORMATO_LOTE_AYUDA_DEFAULT,
};

/**
 * Si la expresión es "exactamente N dígitos" (`^[0-9]{N}$` o `^\d{N}$`),
 * devuelve N: el input conserva el teclado numérico y el filtro de dígitos de
 * siempre. Para cualquier otro formato, null (texto libre hasta 32).
 */
export function digitosExactos(regex: string): number | null {
  const m = /^\^(?:\[0-9\]|\\d)\{(\d{1,2})\}\$$/.exec(regex);
  return m ? Number(m[1]) : null;
}

/** "Ej. 10349723 (8 dígitos)". */
export function placeholderLote(f: FormatoLote): string {
  return `Ej. ${f.ejemplo} (${f.ayuda})`;
}

/** Para `rules.validate` de RHF y validaciones manuales: true o el mensaje. */
export function validarLoteUi(valor: string, f: FormatoLote): true | string {
  return validarLote(valor.trim(), f.regex) || mensajeLoteInvalido(f.ayuda);
}

/** Filtro de tecleo: solo dígitos si el formato es numérico fijo. */
export function limpiarEntradaLote(valor: string, f: FormatoLote): string {
  const n = digitosExactos(f.regex);
  return n !== null ? valor.replace(/\D/g, '').slice(0, n) : valor.slice(0, LOTE_MAX_LEN);
}

/** Props del `<Input>` del lote según el formato. */
export function propsInputLote(f: FormatoLote): {
  inputMode: 'numeric' | 'text';
  maxLength: number;
  placeholder: string;
} {
  const n = digitosExactos(f.regex);
  return {
    inputMode: n !== null ? 'numeric' : 'text',
    maxLength: n ?? LOTE_MAX_LEN,
    placeholder: placeholderLote(f),
  };
}
